import React, { FC, ReactNode } from 'react';
import { useEditor } from '@craftjs/core';

export const SettingsPanel: FC<{ formConfigSettingPanel: ReactNode }> = ({ formConfigSettingPanel }) => {
  const { active, related } = useEditor((state, query) => {
    const currentlySelectedNodeId = query.getEvent('selected').first();
    return {
      active: currentlySelectedNodeId,
      related: currentlySelectedNodeId && state.nodes[currentlySelectedNodeId].related,
    };
  });

  if (!active) {
    return formConfigSettingPanel;
  }

  return related.settings && React.createElement(related.settings);
};
